module.exports = __webpack_public_path__ + "static/media/dream.339d09ac.jpg";